<template>
    <div class="kyc-review row nav-padding">
        <div class="w-full"
             v-if="!selected_company">
            <div class="d-flex align-items-center justify-content-between px-2 pt-3">
                <h5 class="text-black">Pending Review</h5>
                <div class="d-flex align-items-center mr-2 col-md-4">
                    <el-input
                        class="pr-4"
                        placeholder="Search pending reviews"
                        clearable
                        v-model="search_text"
                    />
                </div>
            </div>
            <div class="pt-4">
                <kyc-pending-table
                    :data="filteredData"
                    :parse-status="parseStatus"
                    :parse-status-value="parseStatusValue"
                    :is-loading="isLoadingTableData"
                    @select-company="selectCompany"
                />
            </div>

            <div class="d-flex align-items-center justify-content-between px-2 pt-2">
                <h5 class="text-black">Accounts Review Log</h5>
            </div>
            <div class="pt-2">
                <kyc-review-log-table
                    :data="accountsLogsTableData"
                    :parse-status="parseStatus"
                    :parse-status-value="parseStatusValue"
                    :is-loading="isLoadingAccountsLogsTableData"
                    @select-company="selectCompany"
                />
            </div>
        </div>

        <kyc-account-details
            ref="kycAccountDetails"
            :selected-company="selected_company"
            :parse-status="parseStatus"
            :parse-status-value="parseStatusValue"
            :should-show-back-button="true"
            @change-status="changeStatus"
            @add-note="addNote"
            @back-to-pending-reviews="backToPendingReviews"
            v-else
        />
    </div>
</template>

<script>
import KycPendingTable from './kyc-pending-table'
import KycReviewLogTable from './kyc-review-log-table'
import KycAccountDetails from './kyc-account-details'
import KYC_STATUSES from "../../constants/compliance-kyc-statuses"

export default {
    name: 'KycReview',

    components: {
        KycPendingTable,
        KycReviewLogTable,
        KycAccountDetails
    },

    data() {
        return {
            search_text: '',
            companies: [],
            searching: false,
            no_results: false,
            cancelToken: null,
            selected_company: null,
            isLoadingTableData: false,
            isLoadingAccountsLogsTableData: false,
            isLoadingChangeStatus: false,
            isLoadingAddNote: false,
            tableData: [],
            accountsLogsTableData: [],
            KYC_STATUSES
        }
    },

    computed: {
        filteredData() {
            if (this.tableData && !this.tableData.filter) {
                return []
            }

            return this.tableData?.filter(row => {
                return Object.keys(row).some(key => {
                    return String(row[key]).toLowerCase().indexOf(this.search_text.toLowerCase()) > -1
                })
            })
        },
    },

    methods: {
        backToPendingReviews() {
            this.selected_company = null
            this.getKycSignups()
            this.getKycReviewLogs()
        },

        parseStatus(rowStatus) {
            const matched_status = this.KYC_STATUSES.find(status => status.enumValue === rowStatus)

            return matched_status ? matched_status.label : ''
        },

        parseStatusValue(statusValue) {
            const matched_status = this.KYC_STATUSES.find(status => status.enumValue === statusValue)

            return matched_status ? matched_status.value : ''
        },

        selectCompany(company) {
            this.selected_company = company
        },

        fetchData () {
          this.$refs?.kycAccountDetails?.getKycAccountReviewLogs()
          this.$refs?.kycAccountDetails?.setNoteFieldEmptyAndCloseDialog()
        },

        getKycSignups() {
            this.isLoadingTableData = true

            const params = {
                per_page: 1000
            }

            axios.get('/api/admin/kyc-signups', {params})
                .then(res => {
                    if (res.headers['content-type'] !== 'application/json') {
                        return
                    }

                    if (res.data.data) {
                        this.tableData = res.data.data
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.isLoadingTableData = false
                })
        },

        getKycReviewLogs() {
            this.isLoadingAccountsLogsTableData = true

            const params = {
                per_page: 1000
            }

            axios.get('/api/admin/kyc-review-logs', {params})
                .then(res => {
                    if (res.headers['content-type'] !== 'application/json') {
                        return
                    }

                    if (res.data.data) {
                        this.accountsLogsTableData = res.data.data
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.isLoadingAccountsLogsTableData = false
                })
        },

        changeStatus(row, kyc_status, notes) {
            this.isLoadingChangeStatus = true

            const params = {
                kyc_status,
                notes
            }

            axios.patch(`/api/admin/kyc-signups/${row.id}`, params)
                .then(res => {
                    this.$message({
                        message: 'Status changed successfully',
                        type: 'success'
                    })

                    this.selected_company.company.kyc_status = kyc_status
                    this.fetchData()
                })
                .catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.isLoadingChangeStatus = false
                })
        },

        addNote(row, notes) {
            this.isLoadingAddNote = true

            const params = {
                notes
            }

            axios.patch(`/api/admin/kyc-signups/${row.id}`, params)
                .then(res => {
                    this.$message({
                        message: 'Note added successfully',
                        type: 'success'
                    })

                    this.fetchData()
                })
                .catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.isLoadingAddNote = false
                })
        },
    },

    created() {
        this.getKycSignups()
        this.getKycReviewLogs()
    }
}
</script>
